import { useLanguage } from '../i18n/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang } = useLanguage();
  return (
    <div
      className={`inline-flex items-center gap-1 bg-surface-muted rounded-full p-1 ${className}`}
      data-testid="language-switcher"
      role="group"
      aria-label="Language"
    >
      <Globe className="w-3.5 h-3.5 text-text-secondary ml-2" aria-hidden="true" />
      {['en', 'es'].map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
            lang === code
              ? 'bg-text-primary text-white'
              : 'text-text-secondary hover:text-text-primary'
          }`}
          data-testid={`lang-toggle-${code}`}
          aria-pressed={lang === code}
        >
          {code === 'en' ? 'EN' : 'ES'}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
